
































import "./invite.less";
import Vue from "vue";
import { mapState, mapGetters } from "vuex";
import UserAvatar from "../../components/common/user-avatar.vue";
import Ajax from "../../lib/ajax";

export default Vue.extend({
  name: "invite-modal",
  components: { UserAvatar },
  props: {
    member: Object,
    show: Boolean,
  },
  data() {
    return {
      sending: false,
      inviteModel: {
        memberId: null,
        role: null,
      },
      rules: {
        memberId: [
          {
            type: "number",
            required: true,
            message: "Please select a user",
            trigger: "blur",
          },
        ],
        role: [
          {
            type: "number",
            required: true,
            message: "Please select a role",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("team", ["currentTeam"]),
    ...mapState("billing", ["billingAccount"]),
    ...mapGetters("team", ["currentTeamInviteRoles"]),
    showModal: {
      get: function () {
        return (this as any).show;
      },
      set: function (newValue) {
        (this as any).$emit("cancel");
      },
    },
    accountUsers() {
      let context = this as any;
      let members = context.billingAccount && context.billingAccount.members ? context.billingAccount.members.filter((m) => m.licenseAssigned === true) : [];
      if (context.currentTeam && context.currentTeam.members) {
        members = members.filter((m) => context.currentTeam.members.filter((member) => member.memberId === m.memberId).length === 0);
      }

      return members;
    },
  },
  watch: {
    showModal(newVal) {
      let context = this as any;
      if (newVal === true) {
        context.inviteModel.memberId = null;
        context.inviteModel.role = null;
      }
    },
  },
  mounted() {
    this.loadAccountInfo();
  },
  methods: {
    loadAccountInfo() {
      this.$store
        .dispatch("billing/getBillingAccountInfo")
        .then((response) => {})
        .finally(() => {});
    },
    handleSend() {
      let context = this;
      event.preventDefault();
      let target = (event.target as any).closest("button") as HTMLButtonElement;
      target.disabled = true;
      context.sending = true;

      let teamId = context.$store.state.team.currentTeam.id;

      let form = context.$refs.InviteForm as any;
      form.validate((valid: boolean) => {
        if (valid) {
          context.$store
            .dispatch("team/inviteMember", {
              data: {
                memberId: context.inviteModel.memberId,
                role: context.inviteModel.role,
                beOwner: false,
                teamId: teamId,
              },
            })
            .then((response) => {
              context.$store.dispatch("team/get", {
                id: teamId,
              });
              context.$emit("cancel");
            })
            .finally(() => {
              context.sending = false;
              target.disabled = false;
            });
        } else {
          target.disabled = false;
          context.sending = false;
        }
      });
    },
  },
});
